import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show when user is past 60% of viewport scroll
      const threshold = window.innerHeight * 0.6;
      setShow(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <button
      onClick={scrollUp}
      aria-label="Scroll to top"
      data-testid="scroll-to-top"
      className={`fixed bottom-6 right-6 z-30 w-12 h-12 rounded-full bg-navy text-gold border border-gold/30 shadow-2xl shadow-navy/30 flex items-center justify-center transition-all duration-300 hover:bg-navy-900 hover:-translate-y-1 ${
        show ? "opacity-100 visible translate-y-0" : "opacity-0 invisible translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp size={18} />
    </button>
  );
}
